import { useDispatch } from "react-redux";
import { fetchPatientsAction } from "store/actions/patients";
import { toast } from "react-toastify";
import { useLogout, useCurrentUser } from "utils/hooks";

const useFetchPatients = () => {
  const dispatch = useDispatch();
  const { logOut } = useLogout();
  const { user } = useCurrentUser();

  const fetchAllPatients = () => {
    return new Promise(() => {
      fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
            query {
              getAllPatientsByTherapistId {
                uuid
                firstName
                lastName
                email
                slug
                createdAt
                color
                icon
                alias
                defaultReminder
                notificationTimes
                type
                profile {
                  dob
                  gender
                  status
                  idNumber
                  connectedTherapistId
                }
              }
            }
          `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user?.activeOrganizationId || "NA",
          permissionKey: "read_patients",
        },
      })
        .then(async (res) => {
          if (res.status !== 200 && res.status !== 201) {
            const error = await res.json();
            if (error?.errors?.[0]?.message?.includes("BRKN_6001")) {
              toast.warn(`For security purposes please log in again.`);
              logOut();
            } else {
              toast.error(`Hmm, something went wrong.`);
              throw new Error("Failed!");
            }
          }
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            toast.error(
              `Hmm, something went wrong. ${resData.errors[0]?.message}`
            );
          } else {
            return dispatch(
              fetchPatientsAction(resData.data.getAllPatientsByTherapistId)
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  };

  return {
    fetchAllPatients,
  };
};

export default useFetchPatients;
